import { render, staticRenderFns } from "./GlobalNewsCreate.vue?vue&type=template&id=787c0281&scoped=true"
import script from "./GlobalNewsCreate.vue?vue&type=script&lang=js"
export * from "./GlobalNewsCreate.vue?vue&type=script&lang=js"
import style0 from "./GlobalNewsCreate.vue?vue&type=style&index=0&id=787c0281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c0281",
  null
  
)

export default component.exports